import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { Link } from "react-router-dom"
import Footer from "../components/footer"
import { Drawer, Button } from "antd"
import FloatingInput from "../components/floatingInput"

const OnboardingPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }
    return (
        <Navbar active={"profile"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full">Onboarding</h1>
            </div>
            <div className="relative top-14">
                <div className="min-h-[90vh]">
                    <div className="lg:px-10 px-4 flex lg:flex-row flex-col gap-6 mt-6 justify-between max-w-[1160px] m-auto">
                        <div className="lg:w-1/2">
                            <div className="flex justify-between items-center">
                                <h1 className="font-semibold">Emergency Contact</h1>
                                <span className="uppercase underline text-cyan-900 text-sm cursor-pointer" onClick={showDrawer}>Edit</span>
                            </div>
                            <div className="p-3 flex flex-col gap-y-2 rounded-lg mt-2 font-medium text-[14px]" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                                <div className="flex items-center">
                                    <span>Name</span>
                                    <span>
                                        {/* username */}
                                    </span>
                                </div>
                                <div className="flex items-center">
                                    <span>Relation</span>
                                    <span>
                                        {/* username */}
                                    </span>
                                </div>
                                <div className="flex items-center">
                                    <span>Phone</span>
                                    <span>
                                        {/* username */}
                                    </span>
                                </div>

                            </div>
                        </div>

                        <div className="lg:w-1/2">
                            <div className="flex justify-between items-center">
                                <h1 className="font-semibold">Onboarding Documents</h1>
                            </div>
                            <div className="p-3 flex flex-col gap-y-2 rounded-lg mt-2 font-medium" style={{ boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px" }}>
                                <Link className="hover:underline text-sm">
                                    Orientation & Safety Manual
                                </Link>
                                <Link className="hover:underline text-sm">
                                    Additional information regarding your benefits
                                </Link>
                                <Link className="hover:underline text-sm">
                                    WI State Notice 2022
                                </Link>

                            </div>
                        </div>
                    </div>
                    <Drawer footer={<div className="pt-4">
                        <div className="px-4 flex flex-col gap-y-2">
                            <button className="uppercase py-2 bg-cyan-400 w-full rounded-full">
                                Save
                            </button>
                            <button onClick={onClose} className="m-auto block underline">
                                Cancel
                            </button>
                        </div>
                    </div>}
                        title="Emergency Contact" placement="right" onClose={onClose} open={open}>
                        <div className="flex flex-col gap-y-5">
                            <FloatingInput title={"First Name"} id={"first_Name"}/>
                            <FloatingInput title={"Last Name"} id={"last_Name"}/>
                            <FloatingInput title={"Relation"} id={"relation"}/>
                            <FloatingInput title={"Phone"} id={"phone"}/>
                        </div>
                    </Drawer>
                </div>
                <div className="fixed w-full bottom-0">
                    <Footer />
                </div>
            </div>
        </Navbar>
    )
}

export default OnboardingPage